import { render, staticRenderFns } from "./homeDashboardTeamGoalsNew.vue?vue&type=template&id=15943218&scoped=true"
import script from "./homeDashboardTeamGoalsNew.vue?vue&type=script&lang=js"
export * from "./homeDashboardTeamGoalsNew.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardTeamGoalsNew.vue?vue&type=style&index=0&id=15943218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15943218",
  null
  
)

export default component.exports